import { Injectable } from '@angular/core';
import { sbnbIcon as sbnbGriddyIcon, sbnbGriddyIcons } from '../sbnb-griddy-icons-generated';
import { sbnbIcon, sbnbIcons } from '../sbnb-icons-generated';
export type Icon = sbnbIcon | sbnbGriddyIcon;

@Injectable({
  providedIn: 'root',
})
export class SvgCacheService {
  private cache = new Map<Icon, string>();
  constructor() {
    this.registerIcons();
  }

  getAllIcons() {
    return [...this.cache.keys()];
  }

  getIcon(name: Icon): string {
    return this.cache.get(name) ?? '';
  }

  isIcon(name: string): boolean {
    return this.cache.has(name as Icon);
  }

  private registerIcons(): void {
    sbnbGriddyIcons.forEach(({ name, data }) => {
      this.cache.set(name, data);
    });
    sbnbIcons.forEach(({ name, data }) => {
      this.cache.set(name, data);
    });
  }
}
